import { parseCoordinate } from 'shared/utils';
import { CoordinateFormat } from 'state/useCoordinateFormatState';

export const COORDINATE_FORMAT_TRANS_KEYS: Record<CoordinateFormat, string> = {
  decimal: 'locationListItem.decimalDegrees',
  DDM: 'locationListItem.decimalDegreesMinutes',
  DMS: 'locationListItem.degreesMinutesSeconds',
};

const decimalToDMS = (
  coordinate: number,
  isLatitude: boolean,
  includeSeconds: boolean,
): string => {
  const absolute = Math.abs(coordinate);
  const degrees = Math.floor(absolute);
  const minutesDecimal = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesDecimal);
  const seconds = ((minutesDecimal - minutes) * 60).toFixed(2);

  let direction: string;
  if (isLatitude) {
    direction = coordinate >= 0 ? 'N' : 'S';
  } else {
    direction = coordinate >= 0 ? 'E' : 'W';
  }

  if (includeSeconds) {
    return `${degrees}° ${minutes}' ${seconds}" ${direction}`;
  }

  return `${degrees}° ${minutesDecimal.toFixed(2)}' ${direction}`;
};

const convertDecimalToDMS = (input: {
  lat: number;
  lng: number;
  includeSeconds?: boolean;
}): string => {
  const { lat, lng, includeSeconds = true } = input;
  const formattedLat = decimalToDMS(lat, true, includeSeconds);
  const formattedLng = decimalToDMS(lng, false, includeSeconds);
  return `${formattedLat} ${formattedLng}`;
};

export const getLocationCoords = (input: {
  lat: number;
  lng: number;
  format?: CoordinateFormat;
}): string => {
  const { lat, lng, format = 'decimal' } = input;

  if (format === 'DMS') {
    return convertDecimalToDMS({ lat, lng });
  }

  if (format === 'DDM') {
    return convertDecimalToDMS({ lat, lng, includeSeconds: false });
  }

  return `${parseCoordinate(lat)}, ${parseCoordinate(lng)}`;
};
